import Vue from 'vue'

import CircleProgress from './CircleProgress.vue'
import Loader from './Loader.vue'
import LoaderBlock from './LoaderBlock.vue'
import ImgPlaceholder from './ImgPlaceholder.vue'
import MultipleChoicesDropdown from './MultipleChoicesDropdown.vue'
import Uploader from './Uploader.vue'
import ScrollTopButton from './ScrollTopButton.vue'
import PageFooter from './PageFooter.vue'
import SinglePanelPage from './SinglePanelPage.vue'
import Promo from './Promo.vue'
import InfiniteLoading from 'vue-infinite-loading'
import TextEditor from './TextEditor'
import Dropzone from './Dropzone'
import Modal from './Modal.vue'
import ConfirmModal from './ConfirmModal.vue'
import Newsletter from './Newsletter.vue'
import YearMonthPicker from './YearMonthPicker'
import SimpleItemList from './SimpleItemList'
import PageNumberLinks from './PageNumberLinks'
import Password from './Password'

export default {
  registerCommonComponents,
}

const components = {
  'circle-progress': CircleProgress,
  loader: Loader,
  'img-placeholder': ImgPlaceholder,
  'vb-uploader': Uploader,
  'vb-text-editor': TextEditor,
  ConfirmModal,
  Dropzone,
  InfiniteLoading,
  LoaderBlock,
  Modal,
  MultipleChoicesDropdown,
  Newsletter,
  PageFooter,
  PageNumberLinks,
  Promo,
  ScrollTopButton,
  SimpleItemList,
  SinglePanelPage,
  YearMonthPicker,
  Password,
}

export function registerCommonComponents() {
  for (const name in components) {
    const component = components[name]
    Vue.component(name, component)
  }
}
